import {authHeader, ApiConfigs} from "../_helpers";
import store from '@/store'

export const servicesService = {
    getAll,
    pagination,
}


function getAll() {
    const requestOptions = {
        credentials : 'include' as RequestCredentials,
        method: 'GET',
        headers: {...authHeader(), 'Content-Type': 'application/json'}
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.services.getAll}`, requestOptions).then(handleResponse);

}

function pagination(page: number) {
    const requestOptions = {
        credentials : 'include' as RequestCredentials,
        method: 'GET',
        headers: {...authHeader(), 'Content-Type': 'application/json'}
    };
    return fetch(`${ApiConfigs.base_url + ApiConfigs.services.pagination + page}`, requestOptions).then(handleResponse);
}



function handleResponse(response: any) {
    return response.text().then((text: string) => {
        const data = JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                store.dispatch('authentication/logout')
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}

